import React, { useState } from 'react';
import { Form, Button, Container } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService'; // Import ManagerService

const TaoTaiKhoanComponent = () => {
  const [formData, setFormData] = useState({
    new_username: '',
    new_name: '',
    new_mail: '',
    new_phong_xe: '',
    phone_number: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await ManagerService.submitTaoTaiKhoan(formData);
      alert(response.message); // Hiển thị thông báo từ server
    } catch (error) {
      alert(error.message); // Hiển thị lỗi nếu có
    }
  };

  return (
    <Container fluid className="TaoTaiKhoanComponent mt-4">
      <h2 className="text-center mb-4">Nhập thông tin tài khoản</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="newUsername">
          <Form.Label>Mã nhân viên</Form.Label>
          <Form.Control
            type="text"
            name="new_username"
            value={formData.new_username}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="defaultPassword">
          <Form.Label>Mật khẩu mặc định</Form.Label>
          <Form.Control
            type="text"
            value="123@123"
            readOnly
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="newName">
          <Form.Label>Tên người dùng</Form.Label>
          <Form.Control
            type="text"
            name="new_name"
            value={formData.new_name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="newMail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="new_mail"
            value={formData.new_mail}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="phoneNumber">
          <Form.Label>Số điện thoại Viettel</Form.Label>
          <Form.Control
            type="text"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="newPhongXe">
          <Form.Label>Đơn vị</Form.Label>
          <Form.Select
            name="new_phong_xe"
            value={formData.new_phong_xe}
            onChange={handleChange}
            required
          >
            <option value="" disabled>Chọn đơn vị</option>
            <option value="KD">KD</option>
            <option value="HCM">HCM</option>
            <option value="KT3">KT3</option>
          </Form.Select>
        </Form.Group>

        <Button type="submit" variant="danger" block>
          Xác nhận
        </Button>
      </Form>
    </Container>
  );
};

export default TaoTaiKhoanComponent;
